import { getJSON } from 'redux-api-middleware';

interface IErrorResponse {
  error: string;
  errorInfo: string | undefined;
  statusText: string;
  status: number;
  url: string;
}

/**
 * Customized FSA (Flux Standard Actions) to return an error response equal to the error response of DataFetcher.
 * @todo check if this helper is really necessary, preferably we use the default middleware response
 */
export default async function customFailure(
  response: Response
): Promise<IErrorResponse> {
  const json = await getJSON(response);

  if (json) {
    return {
      error: `${response.status} - ${response.statusText}`,
      errorInfo: json.message,
      statusText: response.statusText,
      status: response.status,
      url: response.url,
    };
  }

  return {
    error: 'Network request failed',
    errorInfo: undefined,
    statusText: `Network request failed: ${response.url}`,
    status: response.status,
    url: response.url,
  };
}
